import { CoffeeMakerCheckOutlineIcon } from './CoffeeMakerCheckOutlineIcon';

/**
 * author: Michael Irigoyen
 * id DDF7AAA6-C0A9-428C-9A2A-1B491714AF82
 * name coffee-maker-check-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coffee-maker-check-outline.svg
 * tags
 * - Home Automation 
 * - Food / Drink 
 */
export const CoffeeMakerCompleteOutlineIcon = CoffeeMakerCheckOutlineIcon;
export default CoffeeMakerCompleteOutlineIcon